import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteCar, getAllCars } from '../redux/actions/carsActions';
import { Row, Col, Popconfirm } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

function Cars() {

    const { cars } = useSelector((state) => state.cars);
    const [totalCars, setTotalcars] = useState([]);

    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getAllCars());
    }, []);

    useEffect(() => {
        setTotalcars(cars);
    }, [cars]);


    return (

        <Row justify="center" gutter={24} className='ml-0'>
            {totalCars.map((car) => {
                return (
                    <Col key={car._id} lg={6} sm={24} xs={24}>
                        <div className="car p-2 bs1">
                            <img src={car.images[0]?.url} className="carimg" />

                            <div className="car-content d-flex align-items-center justify-content-between">
                                <div className="text-left pl-2">
                                    <p>{car.name}</p>
                                    <p> {car.rentPerHour} USD/- Per Booking Hour</p>
                                </div>

                            </div>

                            <div className="car-content d-flex align-items-center justify-content-between">
                                <div className="text-center">
                                    <Link to={`/admin/editcar/${car._id}`}>
                                        <EditOutlined
                                            className="edit"
                                            style={{ color: 'green', cursor: 'pointer', paddingRight: '1rem' }}
                                        />
                                    </Link>

                                    <Popconfirm
                                        title="Are you sure to delete this car?"
                                        onConfirm={()=>{dispatch(deleteCar(car._id));}}
                    
                                        okText="Yes"
                                        cancelText="No">

                                        <DeleteOutlined
                                            className="del"
                                            style={{ color: 'red', cursor: 'pointer', paddingLeft: '1rem' }}
                                        />
                                    </Popconfirm>
                                </div>
                            </div>
                        </div>
                    </Col>
                );
            })}
        </Row>

    );
}

export default Cars;

